/**
 * Workspace loading state — renders while `useWorkspaceStore.loading` is
 * true. Pure shadcn primitives so it matches the rest of the chrome.
 */
import { Skeleton } from "@/components/ui/skeleton";

export function WorkspaceLoadingState(): JSX.Element {
  return (
    <div className="flex h-full flex-col gap-4 p-6">
      <div className="flex items-center justify-between">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-9 w-32" />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 6 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder
          <Skeleton key={i} className="h-40 w-full rounded-lg" />
        ))}
      </div>
    </div>
  );
}
